// extracted by mini-css-extract-plugin
export var contacts = "Contacts-module--contacts--CReI-";
export var item = "Contacts-module--item--+csDa";
export var link = "Contacts-module--link--3h4H4";
export var list = "Contacts-module--list--lnC5q";